module.exports = "<section class=\"padding-md\"\r\n    max-width=\"xl\">\r\n  <header>\r\n    <h2 class=\"typo-title margin-md\">Asociar cotización</h2>\r\n  </header>\r\n</section>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/cotizacion/components/asociar/template.html
// module id = 905
// module chunks = 0